var map = {
	"./bottom-1.png": "SUWV",
	"./bottom-2.png": "7Iic"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Cf9j";


//////////////////
// WEBPACK FOOTER
// ./static/ugc/creation/filter ^\.\/bottom\-.*\.png$
// module id = Cf9j
// module chunks = 1